export const tradeDesk = (): void => {
  // COMMENT OUT IF NEEDED TO TEST IN DEVELOPMENT
  if (process.env.NODE_ENV !== 'development') {
    const firstScript = document.createElement('script')
    firstScript.type = 'text/javascript'
    firstScript.src = 'https://js.adsrvr.org/up_loader.1.1.0.js'
    firstScript.addEventListener('load', addSecondScript)
    document.head.appendChild(firstScript)
  }
}

const addSecondScript = (): void => {
  const secondScript = document.createElement('script')
  secondScript.type = 'text/javascript'
  secondScript.async = false
  secondScript.innerHTML = `
  ttd_dom_ready( function() { if (typeof TTDUniversalPixelApi === 'function') { var universalPixelApi = new TTDUniversalPixelApi();
  universalPixelApi.init("kwe31fb", ["io188t5"], "https://insight.adsrvr.org/track/up");}});
  `
  document.head.appendChild(secondScript)
}
